<template>
  <div class="container">
    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-button v-authority="'5-1'" @click="add" type="primary" size="mini"
        >+ {{ $t("public.add") }}</el-button
      >
      <el-input
        v-model="searchKey"
        style="width: 300px"
        size="mini"
        :placeholder="$t('public.ver1')"
        @keyup.enter.native="toSearch"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="toSearch"
        ></el-button
      ></el-input>
    </div>
    <div class="table">
      <!-- :cell-style="{ padding: '5px' }" -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        ref="table"
        height="100%"
        :empty-text="emptyText"
      >
        <el-table-column
          v-for="(item, index) in column"
          show-overflow-tooltip
          :key="index"
          align="center"
          :prop="column[index].key"
          :label="$t(`public.${column[index].key}`)"
          :width="column.width"
        >
          <template slot-scope="scoped">
            <span v-if="column[index].key == 'time'">
              {{ scoped.row[item.key] ? diffTime(scoped.row[item.key]) : "" }}
            </span>
            <span v-else>
              {{ scoped.row[item.key] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('public.auth')" width="400">
          <!-- :width="column.width" -->

          <template slot-scope="scoped">
            <el-button
              size="small"
              type="primary"
              @click="viewList(scoped.row)"
              >{{
                $t("public.view") +
                `(${scoped.row.stations ? scoped.row.stations.length : 0})`
              }}</el-button
            >
            <el-button
              v-authority="'5-2'"
              size="small"
              type="info"
              @click="edit(scoped.row)"
              >{{ $t("public.edit") }}</el-button
            >
            <el-button
              v-authority="'5-3'"
              size="small"
              type="danger"
              @click="del(scoped.row)"
              >{{ $t("public.del") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <viewList :show.sync="viewShow" :rowInfo="rowInfo" type="view"></viewList>
    <editVue
      :show.sync="editShow"
      :rowInfo="rowInfo"
      type="edit"
      @refush="refush"
    ></editVue>
    <addVue
      :show.sync="addShow"
      :rowInfo="rowInfo"
      type="add"
      @refush="refush"
    ></addVue>
  </div>
</template>

<script>
import editVue from "./components/edit.vue";
import viewList from "./components/viewList.vue";
import addVue from "./components/add.vue";
import { getLoginUsers, delLogin } from "@/api/index";
export default {
  name: "OverseasStationManageLoginSet",
  components: {
    viewList,
    editVue,
    addVue,
  },
  data() {
    return {
      searchKey: "",
      emptyText: this.$t("public.loading"),
      viewShow: false, // 查看列表弹窗
      editShow: false, // 编辑弹窗
      addShow: false, // 编辑弹窗
      rowInfo: {},
      total: 0,
      pageSize: 10,
      page: 1,
      column: [
        { label: "用户名", key: "name" },
        { label: "密码", key: "password" },
        { label: "创建时间", key: "time" },
      ],
      tableData: [],
      allData: [],
      searchData: [], // 搜索数据
    };
  },

  activated() {
    this.getList();
  },
  deactivated() {
    this.page = 1;
  },

  methods: {
    diffTime(time) {
      let t = new Date(time);
      let temp = t.getTime() + this.getLocalTime();
      const dateObj = new Date(temp);
      // 格式化为年-月-日 时:分:秒字符串
      const formattedDateTime = `${dateObj.getFullYear()}-${String(
        dateObj.getMonth() + 1
      ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(
        2,
        "0"
      )} ${String(dateObj.getHours()).padStart(2, "0")}:${String(
        dateObj.getMinutes()
      ).padStart(2, "0")}:${String(dateObj.getSeconds()).padStart(2, "0")}`;
      return formattedDateTime;
    },
    // 返回当地时间和北京时间的时间戳差值
    getLocalTime() {
      let d = new Date();
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60;
      if (time_zone < 0) {
        time_zone = -(Math.abs(time_zone) + 8);
      } else {
        time_zone -= 8;
      }
      return time_zone * 60 * 60 * 1000;
    },
    toSearch() {
      this.emptyText = this.$t("public.loading")

      if (this.searchKey) {
        this.searchData = this.allData.filter((item) =>
          item.name
            .toLocaleLowerCase()
            .includes(this.searchKey.toLocaleLowerCase())
        );
        this.total = this.searchData.length;
        if (!this.searchData.length || this.searchData.length == 0) {
          this.emptyText = this.$t("public.noData");
        }
        this.paging();
      } else {
        this.refush();
      }
    },
    refush() {
      this.page = 1;
      this.getList();
    },
    handleSizeChange() {
      this.paging();
    },
    handleCurrentChange() {
      this.paging();
    },
    getList() {
      getLoginUsers().then((res) => {
        // console.log(res, "resss");
        if (!res.data || !res.data.length || res.data.length == 0) {
          this.emptyText = this.$t("public.noData");
        }
        this.allData = res.data.map((item, index) => {
          return {
            id: index,
            name: item.LoginName,
            password: item.LoginPass,
            time: item.CreatedAt ? item.CreatedAt : "2024-06-17 07:00:00",
            stations: item.Stations.endsWith("|")
              ? item.Stations.slice(0, -1).split("|")
              : item.Stations.split("|"),
            roleIds: item.RoleId,
          };
        });
        this.total = this.allData.length;
        this.paging();
      });
    },
    paging(data = []) {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.page - 1) * this.pageSize;
      // 结束位置 = 当前页 x 每页的大小
      const end = this.page * this.pageSize;
      // this.tableData = this.allData.slice(start, end);
      this.tableData = this.searchKey
        ? this.searchData.slice(start, end)
        : this.allData.slice(start, end);
      // console.log(this.tableData, start, end);
    },
    add() {
      this.addShow = true;
    },
    viewList(row) {
      this.viewShow = true;
      this.rowInfo = row;
    },
    edit(row) {
      this.rowInfo = row;
      this.editShow = true;
    },
    del(row) {
      this.$confirm(this.$t("public.sureDel"), this.$t("public.tip"), {
        confirmButtonText: this.$t("public.submit"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      })
        .then(() => {
          let param = {
            username: row.name,
          };
          delLogin(param).then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.page = 1;
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  height: calc(100% - 30px - 32px - 28px);
  margin-top: 10px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep {
  .table th.el-table__cell {
    background-color: #3e916a;
    color: #fff;
    border: none;
  }
}
</style>